import {getCookie, setCookie} from './index';
import locale_en from '../res/locales/en.js';
import locale_de from '../res/locales/de.js';

const COOKIE_NAME = 'WikINMLanguage';

const LOCALES_AVAILABLE = {
    'en': 'English',
    'de': 'Deutsch'
};

const LOCALES = {
    'en': locale_en,
    'de': locale_de
};

function chooseLocaleCode(desiredCode, defaultCode)
{
    return LOCALES[desiredCode]
        ? desiredCode
        : defaultCode;
}

const LOCALE_CODE_SYSTEM = window.navigator.language || window.navigator.userLanguage; // language of the browser or operating system
const LOCALE_CODE_DEFAULT = chooseLocaleCode(LOCALE_CODE_SYSTEM, Object.keys(LOCALES)[0]);
let LOCALE_CODE; // selected language code

const i18n = {};
export default i18n;

export function getLocales()
{
    return LOCALES_AVAILABLE;
}

export function setLanguage(code)
{
    if(navigator.cookieEnabled === true)
    {
        setCookie(COOKIE_NAME, code, 365);
        window.location.reload();
    }
    else
    {
        if(code === 'de')
            alert('Für diese Funktion müssen Cookies erlaubt sein!');
        else
            alert('Cookies have to be enabled for this function!');
    }
}

export function getLanguage()
{
    return LOCALE_CODE;
}

function init()
{
    const code = getCookie(COOKIE_NAME); // could be null if cookie was not set
    LOCALE_CODE = chooseLocaleCode(code, LOCALE_CODE_DEFAULT);

    // set <html lang="<LOCALE_CODE>">
    document.documentElement.lang = LOCALE_CODE;

    for(let key of Object.keys(LOCALES[LOCALE_CODE])) // copy chosen locale into i18n object
        i18n[key] = LOCALES[LOCALE_CODE][key];
}

init();
